export enum ManualFieldNamesEnum {
    FULL_NAME = 'full_name',
    COUNTRY = 'country',
    CITY = 'city',
    STATE = 'state',
    ZIP = 'zip',
    PHONE = 'phone',
    DOB = 'dob',
    GENDER = 'gender',
    CITIZENSHIP = 'citizenship',
    ADDRESS = 'address',
    EMAIL = 'email',
    INCORPORATION_CERTIFICATE = 'certificate_of_incorporation',
    OWNERSHIP_DOCUMENT = 'ownership_document',
    SSN = 'ssn',
    ADDRESS_LINE1 = 'address_line1',
    ADDRESS_LINE2 = 'address_line2',
}
